'use strict';

/**
 * EmailDataContentAbstract
 * @param  {*} template
 */
class EmailDataContentAbstract {
	constructor(template) {
		// Set type
		this.type = 'EmailDataContentAbstract';

		/// ///////////
		// Template //
		/// ///////////

		// Define templateType
		this.templateType = typeof template;

		// Define template
		this.template = template;
	}

	/**
	 * @function getTemplate
	 * @memberOf EmailDataContentAbstract
	 * @description
	 * Returns unformatted content
	 * @param  {object} data
	 */
	getTemplate(data) {
		switch (this.templateType) {
		case 'function':
			return this.template(data);
		case 'string':
			return this.template;
		}
	}
}

export default EmailDataContentAbstract;
